module.exports = __webpack_public_path__ + "static/k-store-5-45c4dbc3c9234cf1f8915a70bb322019.jpg";